import { Injectable } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { buildQuery, seed, page } from '@albatrosdeveloper/ave-utils-npm/lib/utils/query.util';
import { ceil, get } from 'lodash';
import { takeUntil } from 'rxjs';
import { PaymentOrderService } from '../payment-management/payment-management.service';
import { OrdersPaymentCListExcelExportProcessor } from './order-payment-c-list-excel';
import { OrdersPaymentCListJsonExportProcessor } from './order-payment-c-list-json';
import { ORDER_PAYMENT_LIST_EXPORT_ID, ORDER_PAYMENT_LIST_TITLE } from './order-payment-c-list.constants';
import { ExportContext, ExportFileFormat, ExportRange, ExportService } from 'app/layout/export-overlay';


/** This class is instantiated by a factory (see ExportService).
 * The base ExportTask class takes care of all the functionality of the
 * task, like the current page, the progress and the status of the
 * task. */
@Injectable()
export class OrderPaymentExportC {
  constructor(
    private exportService: ExportService,
    private decimalPipe: DecimalPipe,
    private orderpaymentService: PaymentOrderService,
  ) {}

  export(format: ExportFileFormat, range: ExportRange, totalItems: number, pageSize: number, pageIndex: number) {
    const totalPages = ceil(totalItems / pageSize) + 1;
    this.exportService.task({
      id: ORDER_PAYMENT_LIST_EXPORT_ID,
      title: ORDER_PAYMENT_LIST_TITLE,
      format,
      iterations: range === ExportRange.AllPages ? totalPages : 1,
      processor: format === ExportFileFormat.JSON
        ? new OrdersPaymentCListJsonExportProcessor(this.decimalPipe)
        : new OrdersPaymentCListExcelExportProcessor(this.decimalPipe),
      next: (ctx: ExportContext) => {
        const currentPage = range === ExportRange.AllPages ? ctx.iteration : pageIndex;
        this.orderpaymentService.findByFilter(
          buildQuery(
            seed(this.orderpaymentService.currentFilter), page(currentPage, pageSize)
          ),
          { contextHeader: 'export' },
        ).pipe(takeUntil(ctx.stopped)).subscribe((response) => {
          get(response, 'data.0.data', []).forEach((item) => { ctx.add(item); });
          ctx.next();
        });
      },
    }).start();
  }

  canStartTask() {
    if (this.exportService.taskIsActive(ORDER_PAYMENT_LIST_EXPORT_ID)) {
      this.exportService.setVisible(true);
      return false;
    }
    return true;
  }
}
